import React from 'react'

function RefreshCheck() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      fill="none"
      viewBox="0 0 14 14"
      className="animate-spin mr-2"
    >
      <g clipPath="url(#clip0_20_477)">
        <path
          stroke="#B4B4B4"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.25"
          d="M13.417 2.333v3.5m0 0h-3.5m3.5 0L10.71 3.29a5.25 5.25 0 00-8.662 1.96M.583 11.667v-3.5m0 0h3.5m-3.5 0L3.29 10.71a5.251 5.251 0 008.663-1.96"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_20_477">
          <path fill="#fff" d="M0 0H14V14H0z"></path>
        </clipPath>
      </defs>
    </svg>
  )
}

export default RefreshCheck
